import React, { useState, useRef, useEffect } from 'react';
import './Common.css';
import file_loader from '../../../assets/Main/file_loader.svg';

const FileUpload = ({ onFilesUpload, maxFiles = 3 }) => {
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]); // храним object URLs отдельно
  const fileInputRef = useRef(null);

  // Очистка object URLs при размонтировании или изменении файлов
  useEffect(() => {
    return () => {
      previews.forEach(url => URL.revokeObjectURL(url));
    };
  }, [previews]);

  const updateFiles = (newFiles) => {
    // Очищаем старые превью
    previews.forEach(url => URL.revokeObjectURL(url));

    const newPreviews = newFiles.map(file => URL.createObjectURL(file));
    setPreviews(newPreviews);
    setFiles(newFiles);
    onFilesUpload?.(newFiles);
  };

  const validateFile = (file) => {
    const MAX_SIZE = 10 * 1024 * 1024; // 10 MB
    if (file.size > MAX_SIZE) {
      alert(`Файл «${file.name}» слишком большой (макс. 10 МБ)`);
      return false;
    }
    return true;
  };

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files || []);
    if (selected.length === 0) return;

    const validFiles = selected.filter(validateFile);
    if (validFiles.length < selected.length) {
      // Некоторые файлы отсеялись по размеру
    }

    let total = [...files, ...validFiles];

    if (total.length > maxFiles) {
      alert(`Можно загрузить не более ${maxFiles} файлов.`);
      total = total.slice(0, maxFiles);
    }

    updateFiles(total);
    e.target.value = ''; // сброс input
  };

  const handleRemoveFile = (index) => {
    const newFiles = files.filter((_, i) => i !== index);
    updateFiles(newFiles);
  };

  const handleClick = () => fileInputRef.current?.click();

  const shortenFileName = (name, maxLength = 20) => {
    if (name.length <= maxLength) return name;
    const extIndex = name.lastIndexOf('.');
    const ext = extIndex !== -1 ? name.slice(extIndex) : '';
    const base = extIndex !== -1 ? name.slice(0, extIndex) : name;
    return base.slice(0, maxLength - ext.length - 3) + '...' + ext;
  };

  const isImage = (file) => file.type.startsWith('image/');
  const isVideo = (file) => file.type.startsWith('video/');

  return (
    <div className="file-upload-wrapper">
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        multiple
        accept="image/jpeg,image/png,image/webp,video/mp4,video/quicktime,video/webm,video/x-msvideo,application/pdf,.3gp,.avi,.flv,.m4v,.mkv,.mov,.wmv"
        style={{ display: 'none' }}
      />

      {files.length < maxFiles && (
        <button type="button" className="file-upload-button" onClick={handleClick}>
          <div className="file-upload-content">
            <img src={file_loader} alt="Загрузить" className="file-upload-icon" />
            <span className="file-upload-text">Загрузить файл</span>
          </div>
        </button>
      )}

      {files.length > 0 && (
        <div className="uploaded-files-grid">
          {files.map((file, index) => (
            <div key={index} className="uploaded-file-item">
              <div className="file-preview-wrapper">
                <div className="file-preview">
                  {isImage(file) ? (
                    <img
                      src={previews[index]}
                      alt={file.name}
                      className="preview-img"
                    />
                  ) : isVideo(file) ? (
                    <video
                      src={previews[index]}
                      className="preview-video"
                      muted
                      controls // ← добавили controls для удобства
                    />
                  ) : (
                    <div className="file-icon">📄</div>
                  )}

                  <div className="file-name-overlay" title={file.name}>
                    {shortenFileName(file.name, 24)}
                  </div>
                </div>
              </div>

              <button
                type="button"
                className="remove-file-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveFile(index);
                }}
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FileUpload;